import Grid from '@mui/material/Grid';

import useProfile from '../../../../hooks/providers/useProfile';
import OnboardingSingleStepProgression from '../OnboardingSingleStepProgression/OnboardingSingleStepProgression';

const OnboardingProgression = () => {
  const {selectedFlow} = useProfile();

  return (
    <Grid container spacing={1} mt={2}>
      {selectedFlow.steps.map(s => (
        <OnboardingSingleStepProgression step={s} key={s.step_id} />
      ))}
    </Grid>
  );
};

export default OnboardingProgression;
